import React, { useEffect, useState, useCallback } from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faIdCard, faUsers, faHome, faCheckCircle,
  faTimesCircle, faHeadset, faArrowRight, faStamp,
} from "@fortawesome/free-solid-svg-icons";
import AdminLayout from "./AdminLayout";
import "./admin.css";

function adminFetch(path, opts = {}) {
  const token = localStorage.getItem("adminToken");
  return fetch(path, {
    ...opts,
    headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json", ...(opts.headers || {}) },
  });
}

const STAT_CARDS = [
  { key: "pending_kyc",      label: "Pending KYC",       icon: faIdCard,       accent: "accent-teal"   },
  { key: "total_users",      label: "Total Users",        icon: faUsers,        accent: ""              },
  { key: "total_properties", label: "Properties",         icon: faHome,         accent: ""              },
  { key: "approved_kyc",     label: "Approved KYC",       icon: faCheckCircle,  accent: "accent-green"  },
  { key: "rejected_kyc",     label: "Rejected / Resubmit",icon: faTimesCircle,  accent: "accent-red"    },
  { key: "open_tickets",     label: "Open Tickets",       icon: faHeadset,      accent: "accent-amber"  },
  { key: "pending_property_verifications", label: "Pending Property Verification", icon: faStamp, accent: "accent-teal" },
];

export default function AdminDashboard() {
  const navigate = useNavigate();
  const [stats,   setStats]   = useState(null);
  const [loading, setLoading] = useState(true);
  const [error,   setError]   = useState("");
  const role = localStorage.getItem("adminRole") || "";

  const loadStats = useCallback(async () => {
    setLoading(true);
    try {
      const res  = await adminFetch("/api/admin/stats");
      const data = await res.json();
      if (!res.ok) { setError(data.message || "Failed to load stats."); return; }
      setStats(data);
    } catch {
      setError("Unable to reach server.");
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => { loadStats(); }, [loadStats]);

  return (
    <AdminLayout pageTitle="Dashboard">
      {loading && (
        <div className="adm-spinner-wrap">
          <div className="spinner-border text-secondary" role="status" />
        </div>
      )}
      {error && <div className="adm-alert error">{error}</div>}

      {stats && !loading && (
        <>
          <div className="adm-stats-grid">
            {STAT_CARDS.map((c) => (
              <div key={c.key} className={`adm-stat-card ${c.accent}`}>
                <div className="stat-icon" style={{ color: "var(--adm-muted)" }}>
                  <FontAwesomeIcon icon={c.icon} />
                </div>
                <span className="stat-num">{stats[c.key] ?? "—"}</span>
                <span className="stat-label">{c.label}</span>
              </div>
            ))}
          </div>

          {/* Quick-action shortcuts */}
          <div style={{ display: "flex", gap: ".75rem", flexWrap: "wrap" }}>
            {(role === "super_admin" || role === "kyc_verifier") && (
              <button
                className="adm-btn primary"
                onClick={() => navigate("/admin/kyc")}
              >
                Review KYC Queue
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            )}
            {(role === "super_admin" || role === "property_verifier") && (
              <button
                className="adm-btn primary"
                onClick={() => navigate("/admin/property-verifications")}
              >
                Review Property Queue
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            )}
            {(role === "super_admin" || role === "support") && (
              <button
                className="adm-btn ghost"
                onClick={() => navigate("/admin/users")}
              >
                Manage Users
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            )}
            {(role === "super_admin" || role === "support" || role === "property_verifier") && (
              <button
                className="adm-btn ghost"
                onClick={() => navigate("/admin/properties")}
              >
                Manage Properties
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            )}
            {(role === "super_admin" || role === "support") && (
              <button
                className="adm-btn ghost"
                onClick={() => navigate("/admin/tickets")}
              >
                View Open Tickets
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            )}
            {role === "super_admin" && (
              <button
                className="adm-btn ghost"
                onClick={() => navigate("/admin/team")}
              >
                Manage Team
                <FontAwesomeIcon icon={faArrowRight} />
              </button>
            )}
          </div>
        </>
      )}
    </AdminLayout>
  );
}
